<template>
  <div>
    <ul>
      <li :key="index" v-for="(bread, index) in bread">
        <router-link v-if="bread.path" :to="{path : bread.path }">
          {{ bread.name }}
        </router-link>
        <template v-else>
          {{ bread.name }}
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "BreadCrumbs",
  props: {
    bread: Array,
  },
}
</script>

<style scoped>
ul {
  list-style: none;
  display: flex;
  padding: 0;
  gap: 10px;

}

ul li {
  background: #dd291a;
  padding: 10px 20px;
  border-radius: 5px;
  color: #fff;
}

a {
  color: #fff;
}

a:after {
  content: '>';
  margin-left: 10px;
  position: relative;
  top: 1px;
  font-size: 15px;
}

a:hover {
  text-decoration: none;
}
</style>